import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/system';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';

import CheckBoxItem from 'bento-ordering/base/components/CheckBoxItem';
import VariantFieldSet from 'bento-ordering/base/components/VariantFieldSet';

import { StyledTypographyWithDisabled } from 'components/StyledTypographyWithDisabled';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';

const GridContainer = styled(Grid)({
  display: 'flex'
});

const GridItem = styled(Grid)({
  flexGrow: 1,
  lineHeight: '42px',
  textAlign: 'right'
});

function CheckBoxGroup({
  title,
  required,
  helperText,
  onChange,
  value,
  list,
  disabled,
  hasInvestorDayFeature
}) {
  const styles = { variant: ITEM_DESCRIPTION_AND_PRICES };
  /**
   * This handles the change for when a user update a checkbox.
   * We maintain the value of existing checkboxes, and add/overwrite
   * the checkbox value that the user just interacted with.
   * value props stored ex:
   * {
   *  ketchup: false,
   *  mayo: true,
   *  mustard: true
   * }
   */
  const handleCheckBoxChange = event => {
    onChange({
      ...value,
      [event.target.name]: event.target.checked
    });
  };

  return (
    <VariantFieldSet title={title} required={required} helperText={helperText}>
      <FormGroup>
        <Grid container>
          {list.map((item, index) => {
            const { label, price } = item;
            const selectedValue = item.value;
            const isDisabled =
              (disabled && !value[selectedValue]) || !!item.disabled;

            return (
              <React.Fragment key={index}>
                <GridContainer container style={{ zIndex: 0 }}>
                  <Grid item>
                    <CheckBoxItem
                      checked={!!value[selectedValue]}
                      name={selectedValue}
                      label={label}
                      value={selectedValue}
                      disabled={isDisabled}
                      onChange={handleCheckBoxChange}
                      required={required}
                    />
                  </Grid>
                  <GridItem item>
                    <StyledTypographyWithDisabled
                      component="span"
                      id="item-price"
                      isDisabled={isDisabled}
                      {...styles}
                    >
                      {!hasInvestorDayFeature && price ? `+$${price}` : ' '}
                    </StyledTypographyWithDisabled>
                  </GridItem>
                </GridContainer>
              </React.Fragment>
            );
          })}
        </Grid>
      </FormGroup>
    </VariantFieldSet>
  );
}

CheckBoxGroup.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.object,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  helperText: PropTypes.string,

  isSizeSection: PropTypes.bool.isRequired,
  hasInvestorDayFeature: PropTypes.bool.isRequired
};

CheckBoxGroup.defaultProps = {
  value: {}
};

export default CheckBoxGroup;
